import { render, staticRenderFns } from "./ResourceItemList.vue.js?vue&type=template&id=0fdfbd83!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemList.vue?vue&type=template&id=0fdfbd83"
import script from "./ResourceItemList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemList.vue?vue&type=script&lang=js"
export * from "./ResourceItemList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports